import {
  Box,
  CardProps,
  LinkBox,
  LinkOverlay,
  Stack,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import React from 'react';

import { useSmartyContext } from '../../../components/Geolocation/geolocation.context';
import { isExternalLink } from '../../../utils/link.utils';
import { WLButton, WLH2, WLOverline, WLText } from '../..';
import ImageHandler from '../../ImageHandler';

interface CardV2Props {
  id: string;
  href: string;
  image: React.JSX.Element | undefined;
  actionLabel: string;
  overline?: string | null;
  heading: React.ReactNode[];
  cardText?: string | null;
  children?: React.ReactNode | React.ReactNode[];
  size?: CardProps['size'];
  stateRerender?: boolean;
}

const CardV2: React.FC<CardV2Props> = ({
  id,
  href,
  image,
  actionLabel,
  children,
  heading,
  overline,
  cardText,
  size,
  stateRerender,
}) => {
  const styles = useMultiStyleConfig('CardV2', {
    size,
  });

  const { loaded, location } = useSmartyContext();
  const statesUnderwritten = ['IL', 'NC', 'TX'];
  const statesWithGraphics = [
    'AL',
    'AR',
    'AZ',
    'CO',
    'FL',
    'GA',
    'IA',
    'IL',
    'IN',
    'KY',
    'LA',
    'MI',
    'MS',
    'NC',
    'NJ',
    'OH',
    'OK',
    'OR',
    'PA',
    'SC',
    'TN',
    'TX',
    'VA',
    'WV',
  ];

  return (
    <Stack
      as={LinkBox}
      sx={styles.card}
      role="group"
      rounded="2xl"
      direction={{ base: 'row', laptop: 'column' }}
      spacing={0}
    >
      <Box
        sx={styles.content}
        display="flex"
        flexDirection={'column'}
        justifyContent="space-between"
      >
        <Box sx={styles.copy}>
          <WLOverline sx={styles.overline}>{overline}</WLOverline>
          <WLH2 sx={styles.heading}>
            <LinkOverlay
              href={href}
              isExternal={isExternalLink(href)}
              color={'wl-blue.navy'}
            >
              {heading}
            </LinkOverlay>
          </WLH2>

          {cardText && (
            <WLText marginBottom={4}>
              {cardText}
              {` `}
              {id === '70f51ed9-1925-55d7-856a-82270754771e' &&
                loaded &&
                location &&
                statesUnderwritten.includes(location) && (
                  <WLText as="span" fontSize="xs">
                    Underwritten by Woodmen of the World Life Insurance Society
                  </WLText>
                )}
            </WLText>
          )}
        </Box>
        <WLButton
          textTransform="capitalize"
          colorScheme="wl-blue"
          variant="outline"
          aria-label={actionLabel}
          sx={styles.action}
        >
          {actionLabel}
        </WLButton>
      </Box>
      <Box sx={styles.image} position="relative">
        <Box sx={styles.color} />
        {image}
        {id === '70f51ed9-1925-55d7-856a-82270754771e' &&
          loaded &&
          location &&
          statesWithGraphics.includes(location) && (
            <WLText
              fontSize="xs"
              color="white"
              position={'absolute'}
              left={{ base: '4px', laptop: '8px' }}
              bottom={{ base: '0px', laptop: '8px' }}
              filter={`drop-shadow(0px 0px 2px black);`}
            >
              632976
            </WLText>
          )}
      </Box>
    </Stack>
  );
};

export default CardV2;
